import type { ExitNodeType } from '@/nodes/types';
import { DEFAULT_GUIDE_WRAP_UP, getGuideType } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import { type FC, useContext } from 'react';
import { FlowParamsContext } from '../app/FlowInitializer';

const WRAP_UP_LABELS = {
    summary: 'wrap up',
    skip: 'no wrap up',
} as const;

export const ExitNode: FC<NodeProps<ExitNodeType>> = ({ data }) => {
    const params = useContext(FlowParamsContext);
    // An equipment guide finishes behind a spinner no matter what the exit authored, so labelling it
    // "wrap up" would promise a screen that never renders.
    const wrapUp = getGuideType(params) === 'equipment' ? undefined : (data.wrapUp ?? DEFAULT_GUIDE_WRAP_UP);

    return (
        <div className="border-1 border-red-300 rounded-lg m-1 px-5 py-3 bg-red-100">
            <div className="text-md">Exit</div>
            {wrapUp && <div className="text-xs text-gray-500">{WRAP_UP_LABELS[wrapUp]}</div>}
            <Handle type="target" position={Position.Left} />
        </div>
    );
};
